<template>
  <div class="m-page">
    <div style="margin: 0 auto;text-align: center">
      <ul>
        <li v-if="current>1"><a class="m-wid" href="javascript:void(0);" v-on:click="setCurrent(current - 1)">上一页</a></li>
        <li v-for="index in grouplist" >
          <a href="javascript:void(0);" v-bind:class="{ 'm-active': current == index.val}" v-on:click="setCurrent(index.val)">{{ index.text }}</a>
        </li>
        <li v-if="current<pageNum"><a class="m-wid" href="javascript:void(0);" v-on:click="setCurrent(current + 1)">下一页</a></li>
        <li><a class="m-wid">共{{pageNum}}页</a></li>
      </ul>
    </div>

  </div>
</template>
<script>
  export default{
    name:'mypage',
    data:function () {
      return{
        pageNum:this.page,//总的页数
        current: this.curr,//当前页数
        totalNum:this.total, //总的记录数
        rows:this.rowsNum,
        methodName:this.methName
      }
    },
    watch: {
      //监控变化
      total(val){
        this.totalNum=val;
      },
      curr(val){
        this.current=val;
      },
      page(val){
        this.pageNum=val;
      },
      rowsNum(val){
        this.rows=val;
      },
      methName(val){
          this.methodName = val;
      }

    },
    props:{
      total: {            // 数据总条数
        type: Number,
        default: 0
      },
      rowsNum: {            // 每页多少条数据（一般20）
        type: Number,
        default: 20
      },
      display: {            // 每页显示条数
        type: Number,
        default: 10
      },
      curr: {            // 当前页码
        type: Number,
        default: 1
      },
      page: {            // 总的页码
        type: Number,
        default: 1
      },
      pagegroup: {        // 分页条数 -- 奇数
        type: Number,
        default: 10,
        coerce:function(v){
          v = v > 0 ? v : 5;
          return v % 2 === 1 ? v : v + 1;
        }
      },
      methName:{
        type: String,
        default: 'updatePage',
      }
    },

    created:function () {
    },
    methods: {
      setCurrent: function(idx) {
          if('updatePage' ==this.methodName){
            document.documentElement.scrollTop = document.body.scrollTop = 0;
          }

        if( this.current != idx && idx > 0 && idx < this.page + 1) {
          this.current = idx;
        }
        let star=(idx-1)*this.rows;
        if(star<=0){
          star=0;
        }
        //触发事件
        if(this.methodName){
          this.bus.$emit(this.methodName,{start:star,current:this.current});
        }else{
          this.bus.$emit('updatePage',{start:star,current:this.current});
        }

      }
    },
    computed:{
      grouplist:function(){ // 获取分页页码
        var len = this.pageNum , temp = [], list = [], count = Math.floor(this.pagegroup / 2) ,center = this.current;
        if( len <= this.pagegroup ){
          while(len--){ temp.push({text:this.pageNum-len,val:this.pageNum-len});};
          return temp;
        }
        while(len--){ temp.push(this.pageNum - len);};
        var idx = temp.indexOf(center);
        (idx < count) && ( center = center + count - idx);
        (this.current > this.pageNum - count) && ( center = this.pageNum - count);
        temp = temp.splice(center - count -1, this.pagegroup);
        do {
          var t = temp.shift();
          list.push({
            text: t,
            val: t
          });
        }while(temp.length);
        if( this.pageNum > this.pagegroup ){
          (this.current > count + 1) && list.unshift({ text:'...',val: list[0].val - 1 })&&list.unshift({ text:1,val: 1 });
          (this.current < this.pageNum - count) && list.push({ text:'...',val: list[list.length - 1].val + 1 })&& list.push({ text:this.pageNum,val: this.pageNum});
          (this.current >= this.pageNum - count) && list.push({ text:this.pageNum,val: this.pageNum});
        }

        return list;
      }
    }

  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Page.vue?6f869f26